module.exports = __webpack_public_path__ + "static/img/logo-vip.7639ee1d.png";